import {Link} from 'gatsby';
import React from 'react';

const navItems = [
    {
        name: 'Home',
        href: '/',
    },
];

function Footer() {
    return (
        <footer className="place-self-end  w-full py-8 topo__background">
            <div className="max-w-screen-xl mx-auto px-4 ">
                <ul className="max-w-screen-md mx-auto text-lg text-center font-light flex flex-col lg:flex-row flex-wrap justify-between  ">
                    {navItems.length > 1 && navItems.map((item) => (
                        <li className="my-1" key={item.name}>
                            <Link
                                className="text-white text-sm font-normal  duration-200 hover:underline"
                                to={item.href}
                            >
                                {item.name}
                            </Link>
                        </li>
                    ))}
                </ul>
                <div className="pt-8 flex max-w-xs mx-auto items-center justify-between">
                    <a
                        href="https://m.facebook.com/NeoTreks/"
                        target="BLANK"
                        label="Facebook"
                        title="Facebook"
                        className="text-white   duration-200"
                    >
                        <svg
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="text-xl   duration-200"
                            viewBox="0 0 1792 1792"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1343 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"></path>
                        </svg>
                    </a>

                    <a
                        target="BLANK"
                        href="https://www.linkedin.com/company/neotreks-inc"
                        title="LinkedIn"
                        className="text-gray-100  dark:hover:text-white  duration-200"
                    >
                        <svg
                            width="20"
                            height="20"
                            fill="currentColor"
                            className="text-xl hover:text-gray-800 dark:hover:text-white  duration-200"
                            viewBox="0 0 1792 1792"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M477 625v991h-330v-991h330zm21-306q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zm1166 729v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z"></path>
                        </svg>
                    </a>
                </div>

                <div className="max-w-md mx-auto pt-10 text-sm ">
                    <div className="text-center  text-white  ">
                        NeoTrek Inc, 202 6th Street, Suite 302, Castle Rock, CO 80104
                    </div>
                    <div className="text-center  mx-auto text-white pt-1  ">
                        <span className="ml-3">(719) 966-7304</span>
                        <span className="ml-3">support@accuterra.com</span>
                    </div>
                    <a href="https://neotreks.com/privacy-policy/" target="BLANK">
                        <div className="text-center uppercase text-xs  mx-auto text-white pt-6">
                            Privacy Policy
                        </div>
                    </a>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
